import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';

const API_URL = environment.prismaApiUrl +'/api/dispo/orders';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  currentObject: any;
  isNew: Boolean = false;

  constructor(private http: HttpClient) { }

  getAll(page: number, perPage: number, filterCustomer: number, filterOrderType: number, filterCustomerBranch: number, searchString: string, filterStatus: number, archiveMode: number): Observable<any> {
    return this.http.get(API_URL + '?page=' + page + '&per_page=' + perPage + '&filterCustomer=' + filterCustomer + '&filterOrderType=' + filterOrderType + '&filterCustomerBranch=' + filterCustomerBranch + '&filterStatus=' + filterStatus + '&searchString=' + searchString + '&archiveMode=' + archiveMode 
    );
  }

  getFilter(): Observable<any> {
    return this.http.get(API_URL + '/filter');
  }

  search(string): Observable<any> {
    return this.http.get(API_URL + '/search/' + string);
  }

  export(): Observable<any> {
    return this.http.get(API_URL + '/export',{responseType: 'blob'});
  }

  optPanel(icd,analyseIds): Observable<any> {
    const icdParam = (icd === null || icd === undefined || icd === '' || icd === 'null')
      ? '0'
      : icd;
    return this.http.post<CustomerObject>(API_URL + '/opt-panel/' + icdParam, {data: analyseIds});
  }

  send(): Observable<any> {
    return this.http.get(API_URL + '/send');
  }

  store(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL, {data: object});
  }

  storeCalc(object: any, id): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-calc/' + id, {data: object});
  }

  storePreset(object: any, id: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-preset/' + id, {data: object});
  }

  
  checkPreset(object: any, id: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/check-preset/' + id, {data: object});
  }

  updatePreset(object: any, id: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/update-preset/' + id, {data: object});
  }

  archive(id: any): Observable<any> {
    return this.http.get(API_URL + '/archive/' + id);
  }


  storeMasterAnalyse(object: any, id): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-master-analyse/' + id, {data: object});
  }


  copy(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/copy', {data: object});
  }

  delete(object: any): Observable<any> {
    const id = (object && typeof object === 'object') ? object.id : object;
    return this.http.delete(API_URL + '/' + id);
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/' + id);
    return this.currentObject;
  }

  /** EBM-/Analyse-Katalog für Tab Kalkulation (nicht beim Öffnen der Auftragsdetails). */
  getCalcContext(id: number | string): Observable<any> {
    return this.http.get(API_URL + '/' + id + '/calc-context');
  }

  undispose(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/undispose/' + id);
    return this.currentObject;
  }

  update(object: any): Observable<any> {
    return this.http.put<CustomerObject>(API_URL + '/' + object.id, {data: object});
  }

  genPDF(object: any, columns: any, header: any): Observable<any> {
    console.log(columns);
    return this.http.post(API_URL + '/gen-pdf', {data: object.data, columns: columns, header: header}, {responseType: 'blob'});
  }

  genInvoice(order: any): Observable<HttpResponse<Blob>> {
    return this.http.post<Blob>(`${API_URL}/gen-invoice/${order.id}`, { data: order }, {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  setBilled(orderId: number): Observable<any> {
    return this.http.get(`${API_URL}/set-billed/${orderId}`);
  }

  getCurrentObject() {
    return this.currentObject;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }
}
